__webpack_require__.p = "https://bmidxbbosniaplprod.netlify.app/";